// pages/PresentationPage.jsx
// Page de présentation de l'application

import React from 'react';
import { useTranslation } from 'react-i18next';
import { BookOpen, Languages, Gamepad, List, Brain, Users } from 'lucide-react';
import './PresentationPage.css';

export default function PresentationPage() {
  const { t } = useTranslation();

  return (
    <div className="presentation-page">
      <div className="presentation-container">
        <header className="presentation-header">
          <h1 className="presentation-title">🌍 VocaVerb</h1>
          <p className="presentation-subtitle">{t('presentation.subtitle')}</p>
        </header>

        <section className="presentation-section">
          <h2 className="section-title">{t('presentation.pourquoiTitre')}</h2>
          <p className="section-intro">{t('presentation.pourquoiIntro')}</p>

          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon">
                <BookOpen size={40} color="#3B82F6" />
              </div>
              <h3>{t('presentation.feature1Titre')}</h3>
              <p>{t('presentation.feature1Desc')}</p>
            </div>

            <div className="feature-card">
              <div className="feature-icon">
                <Gamepad size={40} color="#10B981" />
              </div>
              <h3>{t('presentation.feature2Titre')}</h3>
              <p>{t('presentation.feature2Desc')}</p>
            </div>

            <div className="feature-card">
              <div className="feature-icon">
                <List size={40} color="#8B5CF6" />
              </div>
              <h3>{t('presentation.feature3Titre')}</h3>
              <p>{t('presentation.feature3Desc')}</p>
            </div>

            <div className="feature-card">
              <div className="feature-icon">
                <Brain size={40} color="#F59E0B" />
              </div>
              <h3>{t('presentation.feature4Titre')}</h3>
              <p>{t('presentation.feature4Desc')}</p>
            </div>

            <div className="feature-card">
              <div className="feature-icon">
                <Users size={40} color="#EF4444" />
              </div>
              <h3>{t('presentation.feature5Titre')}</h3>
              <p>{t('presentation.feature5Desc')}</p>
            </div>
          </div>
        </section>

        <section className="presentation-section">
          <h2 className="section-title">{t('presentation.fonctionnalitesTitre')}</h2>

          <div className="key-features">
            <div className="key-feature">
              <div className="feature-check">✅</div>
              <span>{t('presentation.keyFeature1')}</span>
            </div>
            <div className="key-feature">
              <div className="feature-check">✅</div>
              <span>{t('presentation.keyFeature2')}</span>
            </div>
            <div className="key-feature">
              <div className="feature-check">✅</div>
              <span>{t('presentation.keyFeature3')}</span>
            </div>
            <div className="key-feature">
              <div className="feature-check">✅</div>
              <span>{t('presentation.keyFeature4')}</span>
            </div>
            <div className="key-feature">
              <div className="feature-check">✅</div>
              <span>{t('presentation.keyFeature5')}</span>
            </div>
            <div className="key-feature">
              <div className="feature-check">✅</div>
              <span>{t('presentation.keyFeature6')}</span>
            </div>
          </div>
        </section>

        <section className="presentation-section">
          <h2 className="section-title">{t('presentation.pourQuiTitre')}</h2>

          <div className="audience-grid">
            <div className="audience-card">
              <div className="audience-icon">🎓</div>
              <h3>{t('presentation.etudiantsTitre')}</h3>
              <p>{t('presentation.etudiantsDesc')}</p>
            </div>

            <div className="audience-card">
              <div className="audience-icon">✈️</div>
              <h3>{t('presentation.voyageursTitre')}</h3>
              <p>{t('presentation.voyageursDesc')}</p>
            </div>

            <div className="audience-card">
              <div className="audience-icon">💼</div>
              <h3>{t('presentation.professionnelsTitre')}</h3>
              <p>{t('presentation.professionnelsDesc')}</p>
            </div>

            <div className="audience-card">
              <div className="audience-icon">📚</div>
              <h3>{t('presentation.passionnesTitre')}</h3>
              <p>{t('presentation.passionnesDesc')}</p>
            </div>
          </div>
        </section>

        <section className="presentation-cta">
          <div className="cta-card">
            <h2>{t('presentation.ctaTitre')}</h2>
            <p>{t('presentation.ctaDesc')}</p>
            <div className="cta-highlight">
              <Languages size={32} color="#10B981" />
              <span>{t('presentation.ctaHighlight')}</span>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}